import { Link } from 'react-router-dom';
import HamburgerButton from '@/layouts/hamburger-button';
import Sidebar from '@/layouts/hydrogen/sidebar';
import Logo from '@core/components/logo';
import HeaderMenuRight from '@/layouts/header-menu-right';
import StickyHeader from '@/layouts/sticky-header';
import { PageTitleSlot } from '@/layouts/hydrogen/page-title';

export default function Header() {
  return (
    // The Marketplace admin portal's top bar: a hairline under it (2026-09-28, non-mechanical edit).
    <StickyHeader className="z-[990] border-b border-muted py-3 3xl:px-8 4xl:px-10">
      {/* No max width: the page's actions sit at the right end of the title slot (page-header.tsx). */}
      <div className="me-4 flex w-full min-w-0 items-center">

        <HamburgerButton
          view={<Sidebar className="static w-full 2xl:w-full" />}
        />
        <Link
          to={'/'}
          aria-label="Site Logo"
          className="me-4 w-9 shrink-0 text-gray-800 hover:text-gray-900 lg:me-5 xl:hidden"
        >
          <Logo iconOnly={true} />
        </Link>

        <PageTitleSlot className="min-w-0 flex-1" />
      </div>

      <HeaderMenuRight />
    </StickyHeader>
  );
}
